import { Link, RemoveIcon, Tooltip } from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../../translations';

type DraftPrescriptionRemoveIconProps = {
   readonly onRemove: VoidFunction;
};

export const DraftPrescriptionRemoveIcon = (props: DraftPrescriptionRemoveIconProps): JSX.Element => {
   return (
      <Tooltip content={draftPrescriptionsTranslationKeys.removeMedicineFromPrescription} testId={'removePrescription'}>
         <Link icon={<RemoveIcon />} onClick={props.onRemove} testId={'removePrescription'} />
      </Tooltip>
   );
};
